import Pagination from 'react-bootstrap/Pagination';

export default function CustomPagination({ currentPage, setCurrentPage, pageTotal }) {
  let pageNumbers = [];
  if (pageTotal <= 5) {
    for (let num = 1; num <= pageTotal; num++) {
      pageNumbers.push(num);
    }
  } else {
    pageNumbers.push(1);
    if (currentPage === 1) {
      pageNumbers.push(currentPage + 1, currentPage + 2);
    } else if (currentPage === pageTotal) {
      pageNumbers.push(currentPage - 2, currentPage - 1);
    } else {
      pageNumbers.push(currentPage - 1, currentPage, currentPage + 1);
    }
    pageNumbers.push(pageTotal);
  }
  const pageNumbersUnique = [...new Set(pageNumbers)];
  const pageNumbersFinal = fillMissingNumbers(pageNumbersUnique);

  function fillMissingNumbers(array) {
    const result = [];
    for (let i = 0; i < array.length - 1; i++) {
      result.push(array[i]);
      const gap = array[i + 1] - array[i];
      gap > 1 && result.push(null);
    }
    result.push(array[array.length - 1]);
    return result;
  }

  return pageTotal ? (
    <Pagination className="d-flex justify-content-center">
      {/* <Pagination.First onClick={() => setCurrentPage(1)} disabled={currentPage === 1} /> */}
      <Pagination.Prev
        onClick={() => setCurrentPage((prev) => prev - 1)}
        disabled={currentPage === 1}
      />
      {pageNumbersFinal.map((num, index) => {
        return num === null ? (
          <Pagination.Ellipsis key={index} disabled />
        ) : (
          <Pagination.Item
            key={index}
            onClick={() => setCurrentPage(num)}
            active={currentPage === num}
          >
            {num}
          </Pagination.Item>
        );
      })}
      <Pagination.Next
        onClick={() => setCurrentPage((prev) => prev + 1)}
        disabled={currentPage === pageTotal}
      />
      {/* <Pagination.Last
        onClick={() => setCurrentPage(pageTotal)}
        disabled={currentPage === pageTotal}
      /> */}
    </Pagination>
  ) : null;
}
